export type FormsSurfaceView = "list" | "create" | "backfill" | "edit" | "profile-edit";

/**
 * The view the Functional Forms surface opens on. Profile setup opens only when
 * it was asked for and the RD has no profile yet, so a stale `?profile=setup`
 * after a save lands on the list (NO-669).
 */
export function initialFormsView({
  initialEditFormId,
  openProfileSetup,
  hasProfile,
}: {
  initialEditFormId: string | null;
  openProfileSetup: boolean;
  hasProfile: boolean;
}): FormsSurfaceView {
  if (openProfileSetup && !hasProfile) return "profile-edit";

  return initialEditFormId ? "edit" : "list";
}
